import { Link } from "react-router-dom";

/**
 * The "final" closing block reused across pages.
 * Primary CTA is "Book a free demo" and routes to the internal /apply page.
 */
export const FinalCTA = ({
  title,
  highlight,
  body,
  ctaLabel = "Book a free demo",
  fine = "A free, no-pitch demo · read-only · no lock-in",
  testIdPrefix = "final",
  to = "/apply",
}) => (
  <section className="pad" style={{ paddingTop: 0 }}>
    <div className="container">
      <div className="final">
        <div className="inner">
          <h2>
            {title}
            {highlight ? (
              <>
                <br />
                <span className="gtext">{highlight}</span>
              </>
            ) : null}
          </h2>
          {body ? <p>{body}</p> : null}
          <Link className="pill" to={to} data-testid={`${testIdPrefix}-cta`}>
            {ctaLabel}
          </Link>
          {fine ? <p className="fine">{fine}</p> : null}
        </div>
      </div>
    </div>
  </section>
);
